/*
 * The auto-generated batch name.
 *
 * PARITY: V1 builds it from the course name, the start date and the SESSION
 * COUNT — not the class duration (AddBatchChild.jsx:126-144, where the prop
 * named `duration` is the session count, set from `course.duration`). The
 * result is what `/add/batch` receives as `batchId`: on create there is no
 * separate id, the trimmed name IS the id.
 *
 * V1 regenerates on every change of those three inputs, discarding whatever the
 * admin had typed. V2 keeps that rule (the field is still editable afterwards)
 * because the name encodes the schedule, so a stale name would misdescribe the
 * batch it creates.
 */

import moment from "moment";

/**
 * @param {Object} input
 * @param {string} input.courseName
 * @param {string} input.startDate - "YYYY-MM-DD"
 * @param {number|string} input.sessions - the course's session count
 * @param {string} input.uniqueId - from `utils/others` → `getUniqueId()`
 * @returns {string} e.g. "EngGra6-14May26-48-0JR5SJ"; "" when an input is missing
 */
export const buildBatchName = ({ courseName, startDate, sessions, uniqueId }) => {
  if (!courseName || !startDate || !sessions) return "";

  const compressed = (courseName?.split?.(" ") ?? [])
    .map((word) => word?.slice(0, 3))
    .join("");

  return `${compressed}-${moment(startDate, "YYYY-MM-DD").format(
    "DDMMMYY",
  )}-${sessions}-${uniqueId}`.trim();
};
